import { connect } from 'react-redux';
import LineRow from './LineRow';
import { selectSubscription } from '../../../modules/Dashboard';
import { updatePhoneLineAlias } from '../../../modules/PhoneLines/actions';
import { phoneLinesEditingSelector } from '../../../modules/PhoneLines/selectors';

function mapStateToProps(state) {
  return {
    isEditing: phoneLinesEditingSelector(state),
  };
}

const mapDispatchToProps = {
  selectSubscription,
  updatePhoneLineAlias,
};

export default connect(mapStateToProps, mapDispatchToProps)(LineRow);
